import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.FMSplusReviewRatingType,
  LocationVarKey.ReviewEmailReceiptThreshold,
  LocationVarKey.FMSReviewStart1,
  LocationVarKey.FMSReviewStart2,
  LocationVarKey.FMSplusPromoterShortlinkEnabled,
  {
    key: LocationVarKey.FMSplusPromoterSMSShortlink,
    hideIf: IS_NOT_EQUAL(LocationVarKey.FMSplusPromoterShortlinkEnabled, "1")
  },
  {
    key: LocationVarKey.FMSReviewPromoter1,
    hideIf: IS_EQUAL(LocationVarKey.FMSplusPromoterShortlinkEnabled, "1")
  },
  {
    key: LocationVarKey.FMSplusPromoter1Shortlink,
    hideIf: IS_NOT_EQUAL(LocationVarKey.FMSplusPromoterShortlinkEnabled, "1")
  },
  LocationVarKey.FMSReviewPromoter2,
  LocationVarKey.FMSReviewPromoter3,
  LocationVarKey.FMSReviewPassive1,
  LocationVarKey.FMSReviewPassive2,
  LocationVarKey.FMSReviewPassive3,
  LocationVarKey.FMSReviewDetractor1,
  LocationVarKey.FMSReviewDetractor2,
  LocationVarKey.FMSReviewDetractor3
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="This workflow is triggered wherever 'Start Review Solicitation' is toggled on.">
        FMS+ Review Solicitations
      </PageHeader>
      <DropdownRow
        {...page}
        label="Rating Scale"
        marginTop
        keyName={LocationVarKey.FMSplusReviewRatingType}
        options={[
          { label: "1-10", value: "1-10" },
          { label: "1-5 stars", value: "1-5 stars" }
        ]}
      />
      <div className="cortexDescription">Ask tenants to review their experience on a scale from 1-10 or 1-5 stars</div>
      <InputRow {...page} keyName={LocationVarKey.ReviewEmailReceiptThreshold} label="Rating Trigger" />
      <div className="cortexDescription">Ratings less than or equal to this value will trigger an email to the store and DM</div>
      <SectionHeader {...page}> Initial Message </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FMSReviewStart1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2"
        keyName={LocationVarKey.FMSReviewStart2}
        enableSwitchVar={LocationVarKey.FMSReviewStart2Enabled}
      />

      <SectionHeader
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.FMSplusReviewRatingType, "1-5 stars")}
        subheading="Customers giving a rating of 9 and above are considered a promoter"
      >
        {" "}
        Promoter (9+ Rating){" "}
      </SectionHeader>
      <SectionHeader
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusReviewRatingType, "1-5 stars")}
        subheading="Customers giving a rating of 5 stars are considered a promoter"
      >
        {" "}
        Promoter (5 Stars){" "}
      </SectionHeader>
      <SwitchRow {...page} keyName={LocationVarKey.FMSplusPromoterShortlinkEnabled} label="Use Shortlink" />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusPromoterShortlinkEnabled, "1")}
        keyName={LocationVarKey.FMSplusPromoterSMSShortlink}
        label="Link to Shorten"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.FMSplusPromoterShortlinkEnabled, "1")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.FMSReviewPromoter1}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusPromoterShortlinkEnabled, "1")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.FMSplusPromoter1Shortlink}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.FMSReviewPromoter2}
        enableSwitchVar={LocationVarKey.FMSReviewPromoter2Enabled}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.FMSReviewPromoter3}
        enableSwitchVar={LocationVarKey.FMSReviewPromoter3Enabled}
      />

      <SectionHeader
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.FMSplusReviewRatingType, "1-5 stars")}
        subheading="Customers giving a rating between 6 & 8 are considered passive"
      >
        {" "}
        Passive (6-8 Rating){" "}
      </SectionHeader>
      <SectionHeader
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusReviewRatingType, "1-5 stars")}
        subheading="Customers giving a rating of 3 or 4 stars are considered passive"
      >
        {" "}
        Passive (3-4 Stars){" "}
      </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FMSReviewPassive1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.FMSReviewPassive2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message After Feedback is Provided"
        keyName={LocationVarKey.FMSReviewPassive3}
        enableSwitchVar={LocationVarKey.FMSReviewPassive3Enabled}
      />

      <SectionHeader
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.FMSplusReviewRatingType, "1-5 stars")}
        subheading="Customers giving a rating of 5 or below are considered a detractor"
      >
        {" "}
        Detractor (5 or Less){" "}
      </SectionHeader>
      <SectionHeader
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusReviewRatingType, "1-5 stars")}
        subheading="Customers giving a rating of 1 or 2 stars are considered a detractor"
      >
        {" "}
        Detractor (1-2 Stars){" "}
      </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FMSReviewDetractor1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.FMSReviewDetractor2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message After Feedback is Provided"
        keyName={LocationVarKey.FMSReviewDetractor3}
        enableSwitchVar={LocationVarKey.FMSReviewDetractor3Enabled}
      />
    </>
  );
}
